import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import textCss from './assets/text.module.scss';

type PropsType = {
  colorGray?: boolean;
  colorDanger?: boolean;
  colorCharming?: boolean;
  fontSizeSm?: boolean;
  textAlignCenter?: boolean;
};

const Text: FC<PropsWithChildren<PropsType>> = ({
  children,
  colorGray = false,
  colorDanger = false,
  colorCharming = false,
  fontSizeSm = false,
  textAlignCenter = false,
}) => (
  <div
    className={classNames(
      textCss.text,
      { [textCss.text_fontSizeSm]: fontSizeSm },
      { [textCss.text_colorGray]: colorGray },
      { [textCss.text_colorDanger]: colorDanger },
      { [textCss.text_colorCharming]: colorCharming },
      { [textCss.text_textAlignCenter]: textAlignCenter },
    )}
  >
    {children}
  </div>
);

export { Text };
